import React from "react";
import { View } from "react-native";
import variables from "../../../../../styles/variables";
import RectangleLoader from "../shared/RectangleLoader";

const { colors } = variables;

const RacecardAndResultWidgetLoader = () => {
  return (
    <View
      style={{
        borderColor: colors.palette.neutral.x100,
        borderWidth: 2,
        borderStyle: "solid",
        borderRadius: 8,
        width: "100%",
        height: 200,
      }}
    >
      <RectangleLoader width="100%" height={200} />
    </View>
  );
};

export default RacecardAndResultWidgetLoader;
